import NeverKnowinglyUndersoldComponent from './NeverKnowinglyUndersoldComponent';
export default class PurchaseDateAndOrder extends NeverKnowinglyUndersoldComponent {
  constructor() {
    super(document.querySelector('#date-of-purchase'));
  }

  render(state) {
    if (state.alreadyPurchased) {
      this.show();
      this.enableChildInputs();
    } else {
      this.hide();
      this.disableChildInputs();
    }
  }
}
